<mat-form-field dir="rtl" style="text-align: right" *ngIf="_device.shouldntShowNativeControls$ | async; else nativeSelectBlock">
	<mat-select [multiple]="multiple" [formControl]="control">
		<mat-option *ngFor="let value of values" [value]="valueFn(value)">
			{{ displayFn(value) }}
		</mat-option>
	</mat-select>
</mat-form-field>
<ng-template #nativeSelectBlock>
	<select style="min-width: 100px" [multiple]="multiple" [formControl]="control">
		<option *ngFor="let value of values" [value]="valueFn(value)">
			{{ displayFn(value) }}
		</option>
	</select>
</ng-template>
